module.exports = __webpack_public_path__ + "static/media/google-icon.ebaa35df.svg";